import useStatusFilters from "@/composables/v2.1/useStatusFilters";
import { StatusFilterNameType, StatusType } from "@/types/filter.types";
import { reactive } from "@vue/composition-api";

export interface StatusFilterInterface {
    title: string;
    name: StatusFilterNameType;
    query: {
        status: StatusType;
        assignedUser?: unknown;
        assignedTeam?: unknown;
    };
}

interface RootState {
    new: StatusFilterInterface;
    team: StatusFilterInterface;
    personal: StatusFilterInterface;
    open: StatusFilterInterface;
    archive: StatusFilterInterface;
}

const state: RootState = reactive({
    new: {
        title: "New",
        name: StatusFilterNameType.NEW,
        query: {
            status: StatusType.OPEN,
            assignedUser: null,
            assignedTeam: null,
        },
    },
    team: {
        title: "Team",
        name: StatusFilterNameType.TEAM,
        query: {
            status: StatusType.OPEN,
            assignedTeam: {
                $notnull: true,
            },
            assignedUser: {
                $isnull: true,
            },
        },
    },
    personal: {
        title: "Personal",
        name: StatusFilterNameType.PERSONAL,
        query: {
            status: StatusType.OPEN,
            assignedUser: 0,
        },
    },
    open: {
        title: "Open",
        name: StatusFilterNameType.OPEN,
        query: {
            status: StatusType.OPEN,
            $or: [
                {
                    assignedUser: {
                        $notnull: true,
                    },
                },
                {
                    assignedTeam: {
                        $notnull: true,
                    },
                },
            ],
        },
    },
    archive: {
        title: "Archived",
        name: StatusFilterNameType.ARCHIVE,
        query: {
            status: StatusType.CLOSED,
        },
    },
});

export default function useEmailStatusFilters() {
    return useStatusFilters(state);
}
